module.exports = __webpack_public_path__ + "static/UNActionAwards-16fa6359e01460a211fd2999686dc10d.png";